/**
 * Helper functions relative to emails for the CreateOrEditUser components.
 */

const EMAIL_DOMAINS_WITH_SUPPORT_RIGHTS = ['manty.eu', 'gig-conseil.fr'];

/**
 * Helper to check the email domain is allowed to get support rights
 * @param  {string} email - User email
 */
export const isEmailDomainSupportWhitelisted = (email: string) =>
    EMAIL_DOMAINS_WITH_SUPPORT_RIGHTS.some((emailDomain) =>
        email.endsWith(`@${emailDomain}`),
    );

type HasEmail = {
    email: string;
};

/**
 * Helper to lower the email and replace it in the input parameter
 * @param {UserCreationFormState} userData - The content of the user creation/edition form
 */
export const updateEmailToLowercase = <T extends HasEmail>(userData: T): T => {
    const lowercasedEmail = userData.email.toLowerCase();
    return { ...userData, email: lowercasedEmail };
};
